module.exports = __webpack_public_path__ + "img/17.897301cc.png";